/**
 * Luth Size guide — link beside Size variant, content by collection (Admin → Size guides)
 */
(function () {
  const apiBase = (window.LuthSizeGuide && window.LuthSizeGuide.apiUrl) || '';
  const handles = (window.LuthSizeGuide && window.LuthSizeGuide.collections) || [];
  if (!apiBase || !handles.length) return;

  const buttons = document.querySelectorAll('.luth-size-guide-btn, [data-open-sizeguide]');
  if (!buttons.length) return;

  function ensureModal() {
    let modal = document.getElementById('luth-size-guide-modal');
    if (modal) return modal;
    modal = document.createElement('div');
    modal.id = 'luth-size-guide-modal';
    modal.className = 'luth-sg-modal';
    modal.hidden = true;
    modal.innerHTML =
      '<div class="luth-sg-modal__backdrop" data-luth-sg-close></div>' +
      '<div class="luth-sg-modal__panel" role="dialog" aria-modal="true" aria-labelledby="luth-sg-title">' +
      '<button type="button" class="luth-sg-modal__close" data-luth-sg-close aria-label="Close">&times;</button>' +
      '<h2 id="luth-sg-title" class="luth-sg-modal__title">Size guide</h2>' +
      '<div class="luth-sg-modal__body">' +
      '<img class="luth-sg-modal__img" alt="Size guide" />' +
      '<p class="luth-sg-modal__caption" hidden></p>' +
      '</div></div>';
    document.body.appendChild(modal);
    modal.querySelectorAll('[data-luth-sg-close]').forEach((el) => {
      el.addEventListener('click', () => closeModal());
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
    return modal;
  }

  let guide = null;

  function openModal() {
    if (!guide || !guide.imageUrl) return;
    const modal = ensureModal();
    const img = modal.querySelector('.luth-sg-modal__img');
    const cap = modal.querySelector('.luth-sg-modal__caption');
    const title = modal.querySelector('.luth-sg-modal__title');
    img.src = guide.imageUrl;
    img.alt = guide.title ? guide.title + ' size guide' : 'Size guide';
    title.textContent = 'Size guide';
    if (guide.caption) {
      cap.hidden = false;
      cap.textContent = guide.caption;
    } else {
      cap.hidden = true;
      cap.textContent = '';
    }
    modal.hidden = false;
    document.documentElement.classList.add('luth-sg-open');
  }

  function closeModal() {
    const modal = document.getElementById('luth-size-guide-modal');
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.classList.remove('luth-sg-open');
  }

  const q = encodeURIComponent(handles.join(','));
  fetch(apiBase.replace(/\/$/, '') + '/api/size-guide?collections=' + q, { credentials: 'omit' })
    .then((r) => r.json())
    .then((data) => {
      guide = data && data.guide;
      if (!guide || !guide.imageUrl) return;
      buttons.forEach((btn) => {
        btn.hidden = false;
        btn.removeAttribute('aria-hidden');
        btn.classList.remove('m:hidden');
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          openModal();
        });
      });
    })
    .catch(() => {});
})();
